import { Point3D } from '../../team-apis/otterdam/answers/shape-typings';
import { XYZWQuaternionTuple } from '../../team-apis/otterdam/calibration-data';

export interface Location {
  position: Point3D;
  rotation: XYZWQuaternionTuple;
  timestamp?: number;
}

export function getLocationTimestamp(
  locations: Location[] | undefined,
  frameNumber: number,
) {
  return locations?.[frameNumber]?.timestamp || 0;
}
